module.exports = __webpack_public_path__ + "img/quick.cfc91827.png";